module.exports = __webpack_public_path__ + "static/norfolk-cc1d75d09252a6b5ca1a9bda0bc280ab.png";